import PortalIdParser from 'PortalIdParser';
import { setSetting, getSetting } from 'calling-internal-common/utils/localSettings';
export class _CrossTabManager {
  // how often to update the cross-tab list
  // how long before disconnecting tab

  // Default value for usesCallingWindow = false

  constructor() {
    this.INITIAL_TAB_LAST_UPDATED_DATA = {
      lastUpdatedTabId: '',
      lastUpdated: 0
    };
    this.INITIAL_TAB_LIST_DATA = {};
    this.CROSS_TAB_HEARTBEAT_FREQUENCY = 1000;
    this.HEARTBEAT_LOSS_TIMEOUT = 3000;
    this.connectionId = '';
    this.storageTabListKey = 'Tab_List-{portalId}';
    this.storageTabLastUpdatedKey = `Tab_Master-{portalId}`;
    this.handleActiveTab = () => {
      this.setLastUpdatedTab();
      this.setTabListData();
    };
    this.storageTabListKey = `Tab_List-${PortalIdParser.get()}`;
  }
  getConnectionId() {
    return this.connectionId;
  }
  getNextConnectionId() {
    const data = this.getTabListData();
    const nextTab = Object.keys(data).find(tabId => tabId !== this.connectionId && data[tabId]);
    return nextTab;
  }
  getLastUpdatedTab() {
    const value = getSetting(this.storageTabLastUpdatedKey);
    const data = value || this.INITIAL_TAB_LAST_UPDATED_DATA;
    return data.lastUpdatedTabId;
  }
  getLastUpdated() {
    const value = getSetting(this.storageTabLastUpdatedKey);
    const data = value || this.INITIAL_TAB_LAST_UPDATED_DATA;
    return data.lastUpdated;
  }
  setLastUpdatedTab(tabId) {
    const value = {
      lastUpdatedTabId: tabId || this.connectionId,
      lastUpdated: Date.now()
    };
    setSetting(this.storageTabLastUpdatedKey, value);
  }
  matchesLastUpdatedTab() {
    const lastUpdatedTab = this.getLastUpdatedTab();
    const data = this.getTabListData();
    if (data && data[lastUpdatedTab]) {
      return lastUpdatedTab === this.connectionId;
    }

    // Elect new master tab if the current master tab is disconnected
    const nextTab = this.getNextConnectionId();
    if (nextTab) {
      this.setLastUpdatedTab(nextTab);
    }
    return false;
  }
  getTabListData() {
    const value = getSetting(this.storageTabListKey);
    return value || this.INITIAL_TAB_LIST_DATA;
  }
  setTabListData(updatedData) {
    if (!this.connectionId) return;
    if (updatedData) {
      setSetting(this.storageTabListKey, updatedData);
      return;
    }
    const data = this.getTabListData();
    setSetting(this.storageTabListKey, Object.assign({}, data, {
      [this.connectionId]: Date.now()
    }));
  }
  resetCrossTabData() {
    setSetting(this.storageTabLastUpdatedKey, this.INITIAL_TAB_LAST_UPDATED_DATA);
    setSetting(this.storageTabListKey, this.INITIAL_TAB_LIST_DATA);
  }
  startTabManagement() {
    try {
      window.parent.addEventListener('focus', this.handleActiveTab);
      window.parent.document.addEventListener('visibilitychange', this.handleActiveTab);
    } catch (e) {
      // do nothing
    }
    this.handleActiveTab();
  }
  stopTabManagement() {
    try {
      window.parent.removeEventListener('focus', this.handleActiveTab);
      window.parent.document.removeEventListener('visibilitychange', this.handleActiveTab);
    } catch (e) {
      // do nothing
    }
  }
  startCleanupTimer(onCleanup) {
    this.cleanupTimerId = window.setInterval(() => {
      if (this.matchesLastUpdatedTab()) {
        this.cleanUpIdleTabs(this.HEARTBEAT_LOSS_TIMEOUT, onCleanup);
      }
    }, this.HEARTBEAT_LOSS_TIMEOUT);
  }
  stopCleanupTimer() {
    if (this.cleanupTimerId) {
      clearInterval(this.cleanupTimerId);
      this.cleanupTimerId = undefined;
    }
  }
  startCrossTabHeartbeat() {
    this.crossTabHeartbeatTimerId = window.setInterval(() => {
      this.setTabListData();
    }, this.CROSS_TAB_HEARTBEAT_FREQUENCY);
  }
  stopCrossTabHeartbeat() {
    if (this.crossTabHeartbeatTimerId) {
      clearInterval(this.crossTabHeartbeatTimerId);
      this.crossTabHeartbeatTimerId = undefined;
    }
  }
  cleanUpIdleTabs(heartbeatLossTimeout, onTabsChanged) {
    const currentTime = Date.now();
    const data = this.getTabListData();
    const updatedData = {};
    let hasChanged = false;
    Object.keys(data).forEach(tabId => {
      if (data[tabId] === 0) {
        hasChanged = true;
      } else if (currentTime - data[tabId] > heartbeatLossTimeout) {
        // JavaScript timers are throttled in inactive Chrome tabs
        // Mark tab as disconnected if it hasn't been updated in a while
        updatedData[tabId] = 0;
        hasChanged = true;
      } else {
        updatedData[tabId] = data[tabId];
      }
    });
    if (hasChanged) {
      this.setTabListData(updatedData);

      // Notify child class that tabs have changed
      if (onTabsChanged) {
        onTabsChanged();
      }
    }
  }
}
export const crossTabManager = new _CrossTabManager();